<template>
  <div>
    <el-form ref="formSearch" :inline="true" :model="formData" label-width="80px">
      <el-form-item label="活动主题:">
        <el-input size="small" v-model="formData.theme" placeholder="请输入活动主题"></el-input>
      </el-form-item>
      <el-form-item label="短信内容:">
        <el-input size="small" v-model="formData.fullName" placeholder="请输入短信内容"></el-input>
      </el-form-item>
      <el-form-item label="活动类型:" class="select-input-type">
        <el-select v-model="formData.orderRemark" @change="activeTypeChange">
          <el-option
            v-for="(item, index) in remartList"
            :key="index"
            :value="item.value1"
            :label="item.label"
          ></el-option>
        </el-select>
        <el-select v-model="formData.activityType" @change="activeTypeChange2">
          <el-option
            v-for="(item, index) in remartListOne"
            :key="index"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发送状态:">
        <el-select v-model="formData.orderstatus">
          <el-option
            v-for="(item, index) in statusList"
            :key="index"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="提交时间:">
        <div class="my_select_time">
          <el-date-picker
            prefix-icon="no_icon"
            v-model="formData.orderStartTimeStart"
            type="datetime"
            :placeholder="'选择日期时间'"
            size="small"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 120px;font-size:12px"
            class="time1"
            :clearable="false"
          ></el-date-picker>
          <div class="time_to_text">至</div>
          <el-date-picker
            prefix-icon="no_icon"
            v-model="formData.orderStartTimeEnd"
            type="datetime"
            :placeholder="'选择日期时间'"
            size="small"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 145px;font-size:12px"
            class="time2"
            :clearable="false"
          ></el-date-picker>
          <i class="el-icon-circle-close date_icon1" @click="clearTimeSendTime()"></i>
          <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
        </div>
      </el-form-item>
      <el-form-item label="发送时间:">
        <div class="my_select_time">
          <el-date-picker
            prefix-icon="no_icon"
            v-model="formData.sendStartTimeStart"
            type="datetime"
            :placeholder="'选择日期时间'"
            size="small"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 120px;font-size:12px"
            class="time1"
            :clearable="false"
          ></el-date-picker>
          <div class="time_to_text">至</div>
          <el-date-picker
            prefix-icon="no_icon"
            v-model="formData.sendStartTimeEnd"
            type="datetime"
            :placeholder="'选择日期时间'"
            size="small"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 145px;font-size:12px"
            class="time2"
            :clearable="true"
          ></el-date-picker>
          <i class="el-icon-circle-close date_icon1" @click="clearTimeSendTime1()"></i>
          <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
        </div>
      </el-form-item>&nbsp;&nbsp;&nbsp;
      <el-button
        size="small"
        :disabled="tableLoding"
        class="search"
        @click="submitForm('formSearch')"
      >
        <i
          class="el-icon-search"
          style="display:inline-block;width:14px;height:12px;"
        ></i> 查询
      </el-button>
      <el-button size="small" class="reset" @click="resetForm">重置</el-button>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "input_form",
  props: {
    orderStatusType: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formArray:[],
      statusList: [], // 发送状态
      formData: {
        theme: "", //活动主题
        concent: "", //短信内容
        orderRemark: 0, //活动类型
        activityType: 11,
        orderstatus: "", //发送状态
        orderStartTimeStart: "", //提交时间开始
        orderStartTimeEnd: "", //提交时间结束
        sendStartTimeStart: "", //发送时间开始
        sendStartTimeEnd: "", //发送时间结束
      },
      remartList: [
        {
          label: "官方发送",
          value1: 0,
        },
        {
          label: "平台发送",
          value1:1,
        },
      ],
      remartListOne: [
        // {
        //   label: "全部",
        //   value: "",
        // },
        {
          label:'精准营销',
          value:11
        },
        {
          label:'智能营销',
          value:3
        },
        {
          label: '会员发送',
          value: 1
        },
        {
          label: '订单发送',
          value: 2
        },   
        {
          label: '手动催评',
          value: 7
        },  
        {
          label: '手动回评',
          value: 8
        },   
        {
          label: '手动审核退款',
          value: 9
        },
      
      ],
      remartListThree:[
        {
          label: '全部',
          value: ""
        },
        {
          label: '会员发送',
          value: 1
        },
        {
          label: '订单发送',
          value: 2
        },   
        {
          label: '指定号码发送',
          value: 5
        },         {
          label: '变量短信发送',
          value: 6
        },           
        {
          label: '手动催评',
          value: 7
        },  
        {
          label: "手动回评",
          value: 8,
        },
        {
          label: '手动审核退款',
          value: 9
        }
      ],
      remartListFour:[
        {
          label:'精准营销',
          value:11
        },
        {
          label:'智能营销',
          value:3
        },
        {
          label: '会员发送',
          value: 1
        },
        {
          label: '订单发送',
          value: 2
        },   
        {
          label: '手动催评',
          value: 7
        },  
        {
          label: '手动回评',
          value: 8
        },  
        {
          label: '手动审核退款',
          value: 9
        }
      ],
      remartListTwo: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "提交中",
          value: 6,
        },
        {
          label: "提交失败",
          value: 7,
        },
        {
          label: "待审核",
          value: 1,
        },
        {
          label: "待发送",
          value: 2,
        },
        {
          label: "审核未通过",
          value: 8,
        },
        {
          label: "已取消",
          value: 4,
        },
        {
          label: "发送中",
          value: 9,
        },
        {
          label: "已发送",
          value: 3,
        },
        {
          label: "发送失败",
          value: 5,
        },
      ],
      remartListTwoOther: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "待审核",
          value: 1,
        },
        {
          label: "待发送",
          value: 3,
        },
        {
          label: "审核未通过",
          value: 4,
        },
        {
          label: "已取消",
          value: 5,
        },
        {
          label: "发送中",
          value: 100,
        },
        {
          label: "已发送",
          value: 101,
        },
        {
          label: "发送失败",
          value: 102,
        },
      ],
      payTypeList: [
        {
          label: "货到付款",
          value: 1,
        },
        {
          label: "邮局汇款",
          value: 2,
        },
        {
          label: "自提",
          value: 3,
        },
        {
          label: "在线支付",
          value: 4,
        },
        {
          label: "公司转账",
          value: 5,
        },
        {
          label: "银行转账",
          value: 6,
        },
      ],
      deliveryTypeList: [
        {
          label: "任意时间",
          value: "",
        },
        {
          label: "只工作日送货(双休日、假日不用送)",
          value: "1",
        },
        {
          label: "只双休日、假日送货(工作日不用送)",
          value: "2",
        },
        {
          label: "工作日、双休日与假日均可送货",
          value: "3",
        },
      ],
      orderSourceList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "PC端订单",
          value: "PC端订单",
        },
        {
          label: "农村电商",
          value: "农村电商",
        },
        {
          label: "微信订单",
          value: "微信订单",
        },
        {
          label: "手Q订单",
          value: "手Q订单",
        },
        {
          label: "移动端订单",
          value: "移动端订单",
        },
        {
          label: "其他",
          value: "其他",
        },
      ],
      tableLoding: false,
      city: "",

      mytimestart:"",
      mytimeend:"",
    };
  },
  mounted() {
    this.time();

    this.statusList = this.remartListTwoOther;
  },
  methods: {
time() {
      this.formData.orderStartTimeStart= this.getDateStr(-30) + " 00:00:00";
      this.formData.orderStartTimeEnd=this.getDateStr(0) + " 00:00:00";
       this.formData.orderstatus=""; //短信内容
       this.formData.orderRemark= 0; //活动类型
      this.formData.activityType= 11;
    },
    //活动类型事件
    activeTypeChange(val){
      // debugger;
      if(val===1){
        // 平台
        this.formData.activityType = "",
        this.remartListOne = this.remartListThree;
        this.statusList = this.remartListTwo;
        this.formData.orderstatus = '';
       
        return;
      }else if(val===0){
        // 官方
        this.remartListOne = this.remartListFour; 
         if (this.formData.activityType==5||this.formData.activityType==6||!this.formData.activityType) {
           this.formData.activityType=11;
         }
         this.statusList = this.remartListTwoOther;
         this.formData.orderstatus = '';
        //  this.formData.activityType="";
         return;
      }
    },
    activeTypeChange2(val){
      this.formData.orderstatus = ''
      if(val!=11 && val!=3){
        this.statusList = this.remartListTwo;
        this.formData.orderstatus = '';
      } else {
        this.statusList = this.remartListTwoOther;
        this.formData.orderstatus = '';
      }
    },
    
    clearTimeSendTime() {
      this.formData.orderStartTimeStart = "";
      this.formData.orderStartTimeEnd = "";
    },
    clearTimeSendTime1(){
            this.formData.sendStartTimeStart = "";
      this.formData.sendStartTimeEnd = "";
    },
    submitForm() {
      this.$emit("onSerach", this.formData);
    },
    resetForm() {
      // var type=this.formData.orderRemark//活动类型
      // var type1=this.formData.activityType//单独
      this.formData= {
        theme: "", //活动主题
        concent: "", //短信内容
        orderRemark: 0, //活动类型
        activityType: 11,
        orderstatus: "", //发送状态
        orderStartTimeStart: this.getDateStr(-30) + " 00:00:00", //提交时间开始
        orderStartTimeEnd: this.getDateStr(0) + " 00:00:00", //提交时间结束
        sendStartTimeStart: "", //发送时间开始
        sendStartTimeEnd: "", //发送时间结束
      },
      this.$emit("onSerach", this.formData);
    },
  },
};
</script>

<style lang="scss" scoped>
// /deep/.my_select_time .el-input__inner {
//   padding: 0px 8px !important;
// }
.el-input,
.el-select {
  width: 280px;
}
.range-num {
  .el-input {
    width: 125px;
  }
  .to {
    padding: 0 8px;
  }
}
.select-input-type {
  .el-select {
    width: 136px;
    margin-right: 8px;
  }
  .el-input {
    width: 136px;
  }
}
.search{
  width: 98px;
      height: 32px;
      font-size: 14px;
      border-radius: 3px;
      color: #fe4d45;
      border: 1px solid #fe4d45 ;
      background-color: #fff;
   &:hover{
      color: #fff ;
      border: 1px solid #fff;
      background-color: #fe4d45;
    }
}.reset{
  width: 98px;
      height: 32px;
      color: #666666;
font-size: 14px;
      border-radius: 3px;
      border: 1px solid #dddddd;
      background-color: #fff;
    &:hover{
      color:#fe4d45 ;
      border: 1px solid #fe4d45;
      background-color: #FFF4F4;
    }
}
.btn_group {
  text-align: center;
}
</style>